import api from './api';

export const getTotaliVendite = async (cantiereId) => {
  const res = await api.get(`/vendite/cantiere/${cantiereId}/totali`);
  return res.data;
};

export const getVenditeDashboard = async (cantiereId) => {
  const res = await api.get(`/vendite/cantiere/${cantiereId}/dashboard`);
  return res.data;
};